import { useCoveoAnalytics } from '@gn-audio/jss-components';

import { useCoveoAnalyticsConfig } from '../providers/useCoveoAnalyticsConfig';

const CoveoUserAnalytics: React.FC = () => {
  const { apiKey, endpoint } = useCoveoAnalyticsConfig();

  useCoveoAnalytics(apiKey || '', endpoint || '');

  return null;
};

export default CoveoUserAnalytics;
